<template>
  <div class="rank" ref="container">
    <div class="list">
      <div
        class="item acea-row row-between-wrapper row-middle"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="left">
          <div class="nickname">{{ item.title }}</div>
          <div class="phone">{{ item.add_time }}</div>
        </div>
        <div class="right red" v-if="item.pm">+{{ item.number }}</div>
        <div class="right green" v-else>-{{ item.number }}</div>
      </div>
      <div class="nolist" v-if="!list.length">暂无数据</div>
    </div>
  </div>
</template>
<script>
import { stocklog } from "../../api/order";
export default {
  name: "rank",
  data() {
    return {
      navlist: [],
      navindex: 0,
      list: [],
      status: 0,
      page: 1,
      id: 0,
      unique: "",
      loading: false,
      loadend: false,
      limit: 10,
      navid: 0,
      yc_type: 0
    };
  },
  mounted() {
    this.yc_type = this.$route.query.yc_type;
    this.id = this.$route.params.id;
    this.unique = this.$route.params.type;
    this.getlist();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getlist();
    });
  },
  methods: {
    getlist() {
      if (this.loading) return;
      if (this.loadend) return;
      let data = {
        page: this.page,
        limit: this.limit,
        pid: this.id,
        unique: this.unique,
        yc_type: this.yc_type
      };
      this.loading = true;
      stocklog(data)
        .then(res => {
          console.log(res);
          this.list = this.list.concat(res.data);
          this.page++;
          this.loading = false;
          this.loadend = this.limit > res.data.length;
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.rank {
  .nav {
    height: 12vw;
    line-height: 12vw;
    text-align: center;
    .item {
      &.on {
        color: #0e98fd;
      }
    }
  }
  .list {
    padding: 4vw;
    .item {
      background: #ffffff;
      padding: 2vw;
      margin-bottom: 2.4vw;
      border-radius: 2vw;
      .left {
        .nickname {
          font-size: 3.73vw;
        }
        .phone {
          font-size: 3.47vw;
          color: #999;
        }
      }
      .right {
        font-size: 3.73vw;
        font-weight: bold;
        &.red {
          color: #fc4142;
        }
        &.green {
          color: rgb(74, 202, 109);
        }
      }
    }
    .nolist {
      text-align: center;
      line-height: 20vw;
    }
  }
}
</style>
